import { authConstants, adminConstants } from '../constants';
import { redirect } from '../utils';
import { AuthApi } from '../services';

export class AuthActions {
    static login (data) {
        return (dispatch) => {
            dispatch({type: authConstants.LOGIN_REQUEST, payload: {...data}});

            AuthApi.login(data)
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true && res.status !== 206) {
                        dispatch({type: authConstants.LOGIN_SUCCESS});  

                        redirect('./'); // redirect to main page

                        return;
                    }

                    // another validation error
                    return dispatch({type: authConstants.LOGIN_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: authConstants.LOGIN_FAILURE});
                });
        }
    }

    static logout () {
        return (dispatch) => {
            dispatch({type: authConstants.LOGOUT_REQUEST});
            
            AuthApi.logout()
                .then((res) => {
                    dispatch({type: authConstants.LOGOUT_SUCCESS});
                }).catch((err) => {
                    dispatch({type: authConstants.LOGOUT_FAILURE});
                });
        }
    }

    /**
     * check if admin logged in by request to get all admins data
     */
    static isAdminLoggedIn () {
        return (dispatch) => {
            dispatch({type: authConstants.AUTH_REQUEST});

            AuthApi.isAdminLoggedIn()
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true && res.data) {
                        dispatch({type: authConstants.AUTH_SUCCESS})

                        // update admin store data
                        dispatch({type: adminConstants.GET_ALL_ADMINS_SUCCESS, payload: [...res.data]});
                        return;
                    }

                    return dispatch({type: authConstants.AUTH_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: authConstants.AUTH_FAILURE});
                });
        }
    }

    static ok(dispatch) {
        return (res) => {
            // if user not logged in
            switch(res.status) {
                case 403: 
                    dispatch({type: authConstants.ADMIN_LOGGED_OUT});
                    break;
                case 206: 
                    dispatch({type: authConstants.ADMIN_2FA_NOT_VERIFY});
                    break;
                default: 
                    break;  
            }

            return res.json();
        }
    }

    /**
     * store location state (from router) if some private router redirect to login
     * @param {Object} locationState 
     */
    static redirectFrom(locationState) {
        return (dispatch) => {
            dispatch({type: authConstants.AUTH_LOGIN_REDIRECT, payload: locationState});
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js